import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AliquotaImpostoDto} from './aliquota-imposto.model';

@Injectable()
export class AliquotaImpostoService {

    constructor(private http: HttpClient) { }

    getAliquotasPorEmpresa(empresaId: number): Observable<HttpResponse<AliquotaImpostoDto[]>> {
        return this.http.get<AliquotaImpostoDto[]>(
            `${environment.webApiSaguiControlUrl}/api/AliquotaImposto/empresa/${empresaId}`,
            { observe: 'response' }
        );
    }

    getAliquotaPorId(id: number): Observable<HttpResponse<AliquotaImpostoDto>> {
        return this.http.get<AliquotaImpostoDto>(
            `${environment.webApiSaguiControlUrl}/api/AliquotaImposto/${id}`,
            { observe: 'response' }
        );
    }



    salvarAliquota(command: AliquotaImpostoDto): Observable<HttpResponse<AliquotaImpostoDto>> {
        return this.http.post<AliquotaImpostoDto>(
            `${environment.webApiSaguiControlUrl}/api/AliquotaImposto/inclui`,
            command,
            { observe: 'response' }
        );
    }

    atualizarAliquota(id: number, command: AliquotaImpostoDto): Observable<HttpResponse<AliquotaImpostoDto>> {
        return this.http.put<AliquotaImpostoDto>(
            `${environment.webApiSaguiControlUrl}/api/AliquotaImposto/atualiza/${id}`,
            command,
            { observe: 'response' }
        );
    }

    excluirAliquota(id: number): Observable<HttpResponse<any>> {
        return this.http.delete(
            `${environment.webApiSaguiControlUrl}/api/AliquotaImposto/cancela/${id}`,
            { observe: 'response' }
        );
    }
}
